export default __webpack_public_path__ + "static/media/card-fuzzy-plus-gray.02e3e2da.jpg";